/* Sui Story — hero headline/eyebrow auto-fit (mobile only).
   Each eyebrow + headline is sized to fill the available width on ONE line:
   short strings grow (up to a cap so they don't get oversized), long strings
   shrink just enough to fit — never wrapping, never clipping. Desktop is left
   to CSS (it already has room + white-space:nowrap).
   Re-runs on first load, after web fonts load, on resize/orientation, and after
   every Barba page swap (via the suistory:page:init event from theme.js). */
(function () {
  var S = (window.SuiStory = window.SuiStory || {});
  var MOBILE_MAX = 749;

  // Caps so short lines stay tasteful rather than ballooning to full width.
  var HEADING_MAX_REM = 2.6;
  var EYEBROW_MAX_REM = 1.0;
  var FILL = 0.96; // leave a sliver of breathing room at the edges

  function rootPx() {
    return parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
  }

  function fitEl(el, maxRem) {
    el.style.fontSize = ''; // reset to the CSS base before measuring
    if (window.innerWidth > MOBILE_MAX) return; // desktop: CSS handles it
    var parent = el.parentElement;
    if (!parent) return;
    var ps = getComputedStyle(parent);
    var avail = parent.clientWidth - parseFloat(ps.paddingLeft || 0) - parseFloat(ps.paddingRight || 0);
    if (!(avail > 0)) return;
    var base = parseFloat(getComputedStyle(el).fontSize);
    var natural = el.getBoundingClientRect().width; // width at the base size
    if (!(natural > 0)) return;
    var target = base * (avail / natural) * FILL; // size that fills the line
    target = Math.min(target, maxRem * rootPx()); // don't oversize short lines
    el.style.fontSize = target.toFixed(2) + 'px';
  }

  S.fitHeroText = function () {
    var heads = document.querySelectorAll('.hero-slider .hero-slide__heading');
    var brows = document.querySelectorAll('.hero-slider .hero-slide__eyebrow');
    for (var i = 0; i < heads.length; i++) fitEl(heads[i], HEADING_MAX_REM);
    for (var j = 0; j < brows.length; j++) fitEl(brows[j], EYEBROW_MAX_REM);
  };

  // Barba swaps + first init both dispatch this.
  document.addEventListener('suistory:page:init', S.fitHeroText);

  // Re-measure once real web fonts (Cormorant/Cinzel) are loaded — metrics change.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(S.fitHeroText);
  }

  // Debounced resize / orientation handling.
  var t;
  function onResize() { clearTimeout(t); t = setTimeout(S.fitHeroText, 150); }
  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', onResize);

  // Run now (covers the very first paint even if the init event was already sent).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', S.fitHeroText);
  } else {
    S.fitHeroText();
  }
})();
